import React from 'react';
import ToggleLayer from '../../containers/ToggleLayer';
import './Layers.css';

const Layers = ({ onLayerClick }) =>
 <div>
   <ul className="layers">
     <ToggleLayer onClick={() => onLayerClick()} />
   </ul>
   <div className="layer-detail"></div>
 </div>


export default Layers;



// WEBPACK FOOTER //
// ./src/components/Layers/Layers.js